import styled from 'styled-components';

export const InputBox = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
  * {
    font-size: 12px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    text-align: left;
  }
`;

export const InputLabel = styled.label`
  text-align: right;
  margin-right: 12px;
  font-size: 14px;
  display: flex;
  flex: 1;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const InputArea = styled.div`
  display: flex;
  flex: 1;
  position: relative;
`;

export const StarLabel = styled.label<{ isFilled?: boolean; disabled?: boolean }>`
  color: ${(props) =>
    props.isFilled ? props.theme.colors['primary-60'] : props.theme.colors['secondary-60']};
  cursor: ${(props) => (props.disabled ? 'initial' : 'pointer')};
  input {
    display: none;
  }
  svg {
    position: relative;
    top: 2px;
  }
`;
